import React from 'react';

import type { NestedFilters, SelectedFilter } from 'src/scenes/BusinessIntelligence/containers/Reporting/types';
import { FilterGroupRelation } from 'src/scenes/BusinessIntelligence/containers/Reporting/types';

type FiltersState = [usedFilters: NestedFilters, setFiltersState: (newState: NestedFilters) => void];

export const useFiltersState = (): FiltersState => {
  const [knownFilters, setKnownFilters] = React.useState<NestedFilters>({
    values: [],
    group: FilterGroupRelation.AND,
  });

  const usedFilters = React.useMemo(
    () => ({
      ...knownFilters,
      values: knownFilters.values.filter((v: SelectedFilter | NestedFilters | null): v is SelectedFilter => !!v),
    }),
    [knownFilters],
  );

  return [usedFilters, setKnownFilters];
};
